import type { IComment } from '@/Module/Comment/Model/DataModel';

export const prepareCommentFullName = (comment: IComment) => {
  if (!comment.person?.name && !comment.person?.family && !!comment.person?.phoneNumber)
    return comment.person?.phoneNumber?.replace(/(\d{6})(\d{3})(\d{2})/, '$1***$3');

  return `${comment.person?.name ? `${comment.person?.name} ` : ''}${comment.person?.family ?? ''}`;
};
